import { useState } from 'react';

export function usePrevious<TValue = unknown>(value: TValue): TValue | undefined;

export function usePrevious<TValue = unknown>(value: TValue, initialValue: TValue): TValue;

export function usePrevious<TValue = unknown>(value: TValue, initialValue?: TValue): TValue | undefined {
  const [current, setCurrent] = useState(value);
  const [previous, setPrevious] = useState(initialValue);

  if (value !== current) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
}
